module.exports = __webpack_public_path__ + "media/IBMPlexSans-SemiBold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-SemiBold.ttf
// module id = 1472
// module chunks = 58